import { createFileRoute } from '@tanstack/react-router'
import { RelatorioAbsenteismoSetor } from '@/features/relatorios-absenteismo-setor'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute(
  '/_authenticated/relatorios/absenteismo-setor/',
)({
  beforeLoad: async () => {
    await requireAdmin()
  },
  component: RelatorioAbsenteismoSetor,
})
